
export {orient2d, orient2dfast} from './esm/orient2d.js';
export {orient3d, orient3dfast} from './esm/orient3d.js';
export {incircle, incirclefast} from './esm/incircle.js';
export {insphere, inspherefast} from './esm/insphere.js';



//////////////////
// WEBPACK FOOTER
// ./~/robust-predicates/index.js
// module id = 760
// module chunks = 0